import React, { Component } from 'react';
import { Table, Button, Input, FormGroup, Label, Alert } from 'reactstrap';

class TieriEditor extends Component {

  formatThresholdValue = (tier, kriterija_tips) => {
    const { threshold_value, zime } = tier;

    if (zime === '-' || zime === 'ir') {
      return '-';
    }

    if (threshold_value === null || threshold_value === undefined) {
      return '-';
    }

    if (kriterija_tips === 'IPATSVARS') {
      return `${(threshold_value * 100).toFixed(0)}%`;
    } else if (kriterija_tips === 'ATTALUMS') {
      return `${threshold_value} m`;
    }

    return threshold_value;
  };

  handleTierChange = (tierKey, field, value) => {
    const { currentVal: tieri = [], setFieldValue, fieldName } = this.props;
    const updatedTieri = tieri.map(tier =>
      this.getTierKey(tier) === tierKey ? { ...tier, [field]: value } : tier
    );
    setFieldValue(fieldName, updatedTieri);
  };

  handleAddTier = () => {
    const { currentVal: tieri = [], setFieldValue, fieldName } = this.props;
    const maxOrder = tieri.length > 0 ? Math.max(...tieri.map(t => t.tier_order)) : 0;

    const newTier = {
      id: null,
      _tempKey: `new_${Date.now()}`,
      tier_order: maxOrder + 1,
      aizsargatibas_pakape: null,
      zime: '-',
      threshold_value: null,
      varbutiba: null,
      sekas: null
    };

    setFieldValue(fieldName, [...tieri, newTier]);
  };

  getTierKey = (tier) => {
    return tier.id || tier._tempKey || `tier_${tier.tier_order}`;
  };

  handleRemoveTier = (tierKey) => {
    const { currentVal: tieri = [], setFieldValue, fieldName } = this.props;
    const updatedTieri = tieri.filter(tier => this.getTierKey(tier) !== tierKey);
    setFieldValue(fieldName, updatedTieri);
  };

  render() {
    const {
      currentVal: tieri = [],
      currentValues = {},
      readOnly,
      extraFieldProps = {}
    } = this.props;

    const kodif = extraFieldProps.kodif || {};
    const kriterija_tips = currentValues.kriterija_tips;

    if (!kriterija_tips) {
      return <Alert color="info">Izvēlieties kritērija tipu, lai konfigurētu sliekšņus</Alert>;
    }

    const sortedTieri = [...tieri].sort((a, b) => a.tier_order - b.tier_order);

    const aizsargatiba_options = kodif.riskaKategorijuAizsargatiba || {};
    const zime_options = kodif.riskaKategorijuZime || {};

    return (
      <div className="tieri-editor">
        <FormGroup>
          <Label>
            <strong>Sliekšņu konfigurācija</strong>
          </Label>

          <Table size="sm" bordered>
            <thead>
              <tr>
                <th style={{width: '30%'}}>Aizsargātības pakāpe</th>
                <th style={{width: '10%'}}>Zīme</th>
                <th style={{width: '15%'}}>Kritērija vērtība</th>
                <th style={{width: '15%'}}>Varbūtība</th>
                <th style={{width: '15%'}}>Sekas</th>
                {!readOnly && <th style={{width: '5%'}}></th>}
              </tr>
            </thead>
            <tbody>
              {sortedTieri.length === 0 ? (
                <tr>
                  <td colSpan={readOnly ? 5 : 6} className="text-center text-muted">
                    Nav konfigurēti slieksni.
                  </td>
                </tr>
              ) : (
                sortedTieri.map((tier, index) => {
                  const tierKey = this.getTierKey(tier);
                  return (
                  <tr key={tierKey}>
                    <td>
                      <Input
                        type="select"
                        value={tier.aizsargatibas_pakape || ''}
                        onChange={(e) => this.handleTierChange(tierKey, 'aizsargatibas_pakape', e.target.value || null)}
                        disabled={readOnly}
                        size="sm"
                      >
                        <option value="">-</option>
                        {Object.keys(aizsargatiba_options).map(key => (
                          <option key={key} value={key}>{aizsargatiba_options[key].nos}</option>
                        ))}
                      </Input>
                    </td>
                    <td>
                      <Input
                        type="select"
                        value={tier.zime || '-'}
                        onChange={(e) => this.handleTierChange(tierKey, 'zime', e.target.value)}
                        disabled={readOnly}
                        size="sm"
                      >
                        {Object.keys(zime_options).map(key => (
                          <option key={key} value={key}>{zime_options[key].nos}</option>
                        ))}
                      </Input>
                    </td>
                    <td>
                      {tier.zime === '-' || tier.zime === 'ir' ? (
                        <span className="text-muted">-</span>
                      ) : (
                        <Input
                          type="number"
                          step={kriterija_tips === 'IPATSVARS' ? '0.01' : '1'}
                          value={tier.threshold_value ?? ''}
                          onChange={(e) => this.handleTierChange(tierKey, 'threshold_value', e.target.value ? parseFloat(e.target.value) : null)}
                          disabled={readOnly}
                          size="sm"
                          placeholder={kriterija_tips === 'IPATSVARS' ? '0.0-1.0' : 'm'}
                        />
                      )}
                    </td>
                    <td>
                      <Input
                        type="number"
                        min="1"
                        max="5"
                        value={tier.varbutiba ?? ''}
                        onChange={(e) => this.handleTierChange(tierKey, 'varbutiba', e.target.value ? parseInt(e.target.value) : null)}
                        disabled={readOnly}
                        size="sm"
                        placeholder="1-5"
                      />
                    </td>
                    <td>
                      <Input
                        type="number"
                        min="1"
                        max="5"
                        value={tier.sekas ?? ''}
                        onChange={(e) => this.handleTierChange(tierKey, 'sekas', e.target.value ? parseInt(e.target.value) : null)}
                        disabled={readOnly}
                        size="sm"
                        placeholder="1-5"
                      />
                    </td>
                    {!readOnly && (
                      <td>
                        <Button
                          color="danger"
                          size="sm"
                          onClick={() => this.handleRemoveTier(tierKey)}
                          title="Dzēst"
                        >
                          <i className="fa fa-trash"></i>
                        </Button>
                      </td>
                    )}
                  </tr>
                  );
                })
              )}
            </tbody>
          </Table>

          {!readOnly && (
            <Button color="primary" size="sm" onClick={this.handleAddTier}>
              <i className="fa fa-plus"></i> Pievienot slieksni
            </Button>
          )}
        </FormGroup>
      </div>
    );
  }
}

export default TieriEditor;
